import { type FC } from 'react';
import { FreeMode, Mousewheel } from 'swiper/modules';
import { useSportUrlParams } from '@mwl/core-lib';
import type { SliderProps } from '@/components/Slider/Slider';
import { Slider } from '@/components/Slider/Slider';
import { SportFilterItem } from '../SportFilterItem/SportFilterItem';
import type { MobileSportFilterProps } from './MobileSportFilter.types';
import styles from './MobileSportFilter.module.scss';
export const sliderProps: SliderProps = {
  modules: [Mousewheel, FreeMode],
  spaceBetween: 8,
  slidesPerView: 'auto',
  freeMode: true,
  mousewheel: {
    forceToAxis: true
  },
  isStartShadow: true,
  isEndShadow: true
};
const MobileSportFilter: FC<MobileSportFilterProps> = ({
  sports,
  className
}) => {
  const {
    sportId
  } = useSportUrlParams();
  return <div className={cn(styles.root, className)} data-sentry-component="MobileSportFilter" data-sentry-source-file="MobileSportFilter.tsx">
      <div className={styles.header}>
        <Slider {...sliderProps} data-sentry-element="Slider" data-sentry-source-file="MobileSportFilter.tsx">
          {sports.map((sportItem, index) => <SportFilterItem key={sportItem.id} sportItem={sportItem} isActive={sportItem.id === sportId} sports={sports} position={index} />)}
        </Slider>
      </div>
    </div>;
};
export { MobileSportFilter };